// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"ada4da45","453":"b05d8aa5","497":"00c64118","571":"faf36563","687":"070c6422","688":"816cb257","706":"67886003","895":"e2b47b43"}[chunkId] + ".chunk.js";
};